// Cloudflare Turnstile site key. Public by design — only validates on
// configured hostnames (carolcare.io). Pair with TURNSTILE_SECRET_KEY
// set as a Pages secret server-side.
export const TURNSTILE_SITE_KEY = "0x4AAAAAADRXdUV-cd3VPGSc";
